import { useState } from 'react'

import { ConfirmDialog } from '../../../components/ConfirmDialog'

interface ICommercialDialogProps {
  isOpen: boolean
  consultantName?: string
  onClose: () => void
  onConfirm: () => Promise<void>
}

/**
 * Shown when a card is dragged into "Comercial": confirms the move and warns
 * that the consultant will be notified by e-mail that the study credit is ready
 * for enrollment.
 */
export function CommercialDialog({ isOpen, consultantName, onClose, onConfirm }: ICommercialDialogProps) {
  const [saving, setSaving] = useState(false)

  const handleConfirm = async () => {
    setSaving(true)
    try {
      await onConfirm()
      onClose()
    } catch {
      // Kept open so the user can retry; the caller already showed the error toast.
    } finally {
      setSaving(false)
    }
  }

  return (
    <ConfirmDialog
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleConfirm}
      action="save"
      title="Mover para Comercial"
      description={
        <>
          Ao confirmar, um e-mail será enviado ao consultor {consultantName ? <strong>{consultantName}</strong> : ''}{' '}
          avisando que o aproveitamento de estudos está pronto para matrícula, com um link para abrir esta solicitação
          no painel.
        </>
      }
      confirmLabel="Confirmar e notificar"
      isLoading={saving}
    />
  )
}
